/* eslint-disable require-jsdoc */

import moment from 'moment';
import 'moment-timezone';
import jstz from 'jstz';
import { debug } from '../config';
const eventTimeConversion = (utcTimeData) => {
  const timezone = jstz.determine();
  const userTimeZone = timezone.name();;
  const eventInUserTimeAndZone =
      moment.utc(utcTimeData).tz(userTimeZone).format('h:mm a z');


  return eventInUserTimeAndZone;
};
const utcDateTimeConversion = (utcTimeData) => {
  debug && console.log('utcdatetime 1 ', utcTimeData);
  const timezone = jstz.determine();
  const userTimeZone = timezone.name();

  const eventInUserTimeAndZone =
      moment.utc(utcTimeData).tz(userTimeZone).format('MMM D, YYYY, h:mm a z');

  return eventInUserTimeAndZone;
};
const utcDate = (utcTimeData) => {
  debug && console.log('utcdatetime 1 ', utcTimeData);
  const timezone = jstz.determine();
  const userTimeZone = timezone.name();
  const eventInUserTimeAndZone =
      moment.utc(utcTimeData).tz(userTimeZone).format('MMM D, YYYY');
  return eventInUserTimeAndZone;
};
function currDate() {
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = today.getFullYear();
  today = yyyy + '-' + mm + '-' + dd;
  return today;
}
const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
function getWeekDay(day) {
  return weekDays[parseInt(day) - 1];
}
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];
function getMonth(month) {
  return months[parseInt(month) - 1];
}
let start, end;
function formatDate(date) {
  switch (date) {
    case 'today':
      start = moment().startOf('day');
      end = moment().endOf('day');
      break;
    case 'tomorrow':
      start = moment().startOf('day').add(1, 'days');
      end = moment().endOf('day').add(1, 'days');
      break;
    case 'this week':
      start = moment().startOf('day');
      end = moment().endOf('week').add(1, 'days');
      break;
    case 'next week':
      start = moment().endOf('week').add(2, 'days').startOf('day');
      end = moment().add(7, 'days').endOf('week').add(1, 'days');
      break;
    case 'this month':
      start = moment().startOf('day');
      end = moment().add(1, 'month');
      break;
    case 'this weekend':
      if (moment().weekday() === 0) {
        start = moment().startOf('day');
        end = moment().endOf('day');
      } else {
        start = moment().endOf('week').startOf('day');
        end = moment().endOf('week').add(1, 'days');
      }
      break;
    default:
      start = moment().startOf('day');
      end = moment().add(3, 'month');
  }
}
function utcToLocalTime(timeUTC) {
  const testDateUtc = moment.utc(timeUTC);
  const localDate = moment(testDateUtc).local();
  return localDate.format('hh:mm a');
}
export {currDate, getMonth, formatDate, getWeekDay, utcToLocalTime, eventTimeConversion, utcDateTimeConversion, utcDate};
